<template>
  <base-box v-bind="$props" v-on="$listeners" />
</template>

<script>
  import BaseBox from '../_base';
  import { BasePropsMixin } from '../_base/_base-mixin';

  export default {
    components: {
      BaseBox
    },
    mixins: [BasePropsMixin]
  };
</script>
